import React from 'react'
import PropTypes from 'prop-types'
import { CSSTransition } from 'react-transition-group'
import Controls from '../containers/Controls.js'
import Tracks from '../containers/Tracks.js'
import Playlists from '../containers/Playlists.js'
import Audio from '../containers/Audio.js'

class Radio extends React.Component {
  constructor () {
    super()
    this.active = false
  }
  componentDidMount () {
    this.active = true
    if (this.props.autoplay === true) {
      this.props.setPlayback(1)
    }
  }
  render () {
    const {
      className,
      big,
      mini
    } = this.props

    const Components = [
      <Playlists key={1} className='fade' />,
      <Tracks key={2} className='fade' />,
      <Controls key={3} className='big fade' />
    ]
    const items = Components.map((Item, i) => (
      <CSSTransition key={i} in={this.active} classNames='fade' timeout={(i * 100) + 200}>
        {Components[i]}
      </CSSTransition>
    ))

    return (
      <div className={className || 'radio'}>
        {
          big &&
          items
        }
        {
          (big || mini) &&
          <Audio />
        }
        {
          mini &&
          <Controls className='mini' mini={true} debug={false} />
        }
      </div>
    )
  }
}

Radio.defaultProps = {
  big: false,
  mini: true,
  autoplay: false
}

Radio.propTypes = {
  className: PropTypes.string,
  big: PropTypes.bool,
  mini: PropTypes.bool,
  autoplay: PropTypes.bool,
  setPlayback: PropTypes.func
}

export default Radio
